export const questionnaire2Questions = [
  {
    id: 'generalInformation_9',

    question:
      'Is any of your connected persons working with PIAS? ',
    inputLabel:
    'If Yes, then remarks',
  },

  {
    id: 'generalInformation_5',

    question:
      'Have you ever executed a deed poll (after onboarded and rnf-coded with PIAS), whether in Singapore or elsewhere?',

    hasAttachment: true,
  },
    {
    id: 'generalInformation_14',

    question:
      'Are you currently providing any professional will writing services, tax planning and estate planning services (excluding referral services such as Enhanced Introducer Agreement with Precept Legacy)?',

  },
    {
    id: 'generalInformation_7',

    question:
      'Are you currently engaged in other gainful employment?',

    hasAttachment: true,
  },
    {
    id: 'generalInformation_10',

    question:
      "Are you currently holding or intend to hold a moneylender's licence or being an employee, director, shareholder, sole proprietor or partner of a licensed moneylender? ",

    hasAttachment: true,
  },
    {
    id: 'generalInformation_11',

    question:
      'Are you currently holding or intend to hold a junket promoter licence or being an employee, director, shareholder, sole proprietor, partner or associate of a licensed junket promoter?',

    hasAttachment: true,
  },
   {
    id: 'generalInformation_12',

    question:
      'Are you currently acting or intend to act as a real estate salesperson or agent, or being an employee, director, shareholder, sole proprietor or partner of a licensed estate agency?',

    hasAttachment: true,
  },
   {
    id: 'generalInformation_13',

    question:
      'Are you currently marketing or intend to market investments not regulated under the Financial Advisers Act or hold any business interests or directorships in firms operating such unregulated schemes e.g. gold buy-back scheme?',

    hasAttachment: true,
  },
];